var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDateFinderBig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "122px",
    height: "123px",
    viewBox: "0 0 122 123",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDateFinderBig") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-10.5%",
    y: "-10.4%",
    width: "121.1%",
    height: "120.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DateFinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Datefinder-without-dates",
    transform: "translate(-126.000000, -1872.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDateFinderBig",
    filter: "url(#filter-1)",
    transform: "translate(130.000000, 1874.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    x: 1.5,
    y: 10.5,
    width: 111,
    height: 103,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11111111,32 L111.888889,32",
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(17.000000, 0.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.5,
    y: 1.5,
    width: 9.78582202,
    height: 17.8590673,
    rx: 4.89291101
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 35.5955254,
    y: 1.5,
    width: 9.78582202,
    height: 17.8590673,
    rx: 4.89291101
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 69.6910508,
    y: 1.5,
    width: 9.78582202,
    height: 17.8590673,
    rx: 4.89291101
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.8557122,51.1644452 C74.5322763,47.8343886 70.1133959,46 65.4125382,46 C61.82614,46 58.402528,47.0682015 55.5053045,49.0535973 C52.6076171,47.0677369 49.1844689,46 45.5980707,46 C40.8976768,46 36.4783326,47.8343886 33.1548967,51.1639806 C29.8305333,54.4935725 28,58.9206381 28,63.6306679 C28,68.3397684 29.8305333,72.7677633 33.1548967,76.0978198 L52.9693643,95.9475962 C53.6696696,96.6491987 54.5879508,97 55.5057682,97 C56.4235857,97 57.3418669,96.6491987 58.042636,95.9471315 L77.8557122,76.0968906 C84.7149945,69.2221149 84.7145307,58.0373623 77.8557122,51.1644452 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateFinderBig);
export default __webpack_public_path__ + "static/media/icDateFinderBig.7d949f074ad3bef58fd308d34704f6c7.svg";
export { ForwardRef as ReactComponent };